import styled, { css } from 'styled-components';
import { GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { grid } from '@bbc/psammead-styles/detection';
var twoOfSixColumnsMaxWidthScaleable = "33.33%"; // (2 / 6) * 100 = 0.3333333333 = 33.33%

var fourOfSixColumnsMaxWidthScaleable = "66.67%"; // (4 / 6) * 100 = 66.6666666667 = 66.67%

var fullWidthColumnsMaxScaleable = "100%"; // (12 / 12) * 100 = 100 = 100%

var halfWidthColumnsMaxScaleable = "50%";
var gridFallbackImageWidth = /*#__PURE__*/css(["width:calc(", " - ", ");"], halfWidthColumnsMaxScaleable, GEL_SPACING);
var ImageGridColumnsTopStory = /*#__PURE__*/css(["grid-column:1 / span 6;@media (min-width:", ") and (max-width:", "){grid-column:1 / span 3;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MAX);
var ImageGridColumns = /*#__PURE__*/css(["grid-column:1 / span 2;"]);
var ImageGridColumnsLeadingStory = /*#__PURE__*/css(["padding:0;grid-template-columns:repeat(6,1fr);grid-column-end:span 6;@media (min-width:", "){grid-template-columns:repeat(3,1fr);grid-column-end:span 3;}@media (min-width:", "){grid-template-columns:repeat(4,1fr);grid-column-end:span 4;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_4_SCREEN_WIDTH_MIN);
var ImageGridFallbackTopStory = /*#__PURE__*/css(["margin-bottom:", ";width:", ";@media (min-width:", "){", ";margin-bottom:0;}@media (min-width:", "){", ";}"], GEL_SPACING, fullWidthColumnsMaxScaleable, GEL_GROUP_3_SCREEN_WIDTH_MIN, gridFallbackImageWidth, GEL_GROUP_4_SCREEN_WIDTH_MIN, gridFallbackImageWidth);
var ImageGridFallback = /*#__PURE__*/css(["width:", ";@media (min-width:", "){display:block;width:100%;}"], twoOfSixColumnsMaxWidthScaleable, GEL_GROUP_4_SCREEN_WIDTH_MIN);

var paddingDir = function paddingDir(_ref) {
  var dir = _ref.dir;
  return "padding-".concat(dir === 'rtl' ? 'right' : 'left');
};

var ImageGridFallbackLeadingStory = /*#__PURE__*/css(["width:", ";@media (min-width:", "){", ":", ";width:", ";}@media (min-width:", "){width:", ";}"], fullWidthColumnsMaxScaleable, GEL_GROUP_3_SCREEN_WIDTH_MIN, paddingDir, GEL_SPACING, halfWidthColumnsMaxScaleable, GEL_GROUP_4_SCREEN_WIDTH_MIN, fourOfSixColumnsMaxWidthScaleable);
var imageGridStyles = {
  top: ImageGridColumnsTopStory,
  regular: ImageGridColumns,
  leading: ImageGridColumnsLeadingStory
};
var imageGridFallbackStyles = {
  top: ImageGridFallbackTopStory,
  regular: ImageGridFallback,
  leading: ImageGridFallbackLeadingStory
};
var ImageGridItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "ImageGridItem",
  componentId: "sc-1xk56cj-0"
})(["display:inline-block;vertical-align:top;position:relative;", " @supports (", "){width:initial;", "}"], function (_ref2) {
  var promoType = _ref2.promoType;
  return imageGridFallbackStyles[promoType];
}, grid, function (_ref3) {
  var promoType = _ref3.promoType;
  return imageGridStyles[promoType];
});
export default ImageGridItem;